import { Injectable } from '@angular/core'

export type FilterSearchInputItem = string;

@Injectable({
    providedIn: 'root',
})
export class FilterHelperService {

    public filterBySearchTerms(input: FilterSearchInputItem[], terms: string): FilterSearchInputItem[] {
        if (! terms?.trim()) {
            return input
        }

        let termsArray = this.normalizeString(terms).split(' ')
        if (termsArray.length > 1) {
            termsArray = [terms, ...termsArray]

            // Exclude single character terms if there is more than one term
            termsArray = termsArray.filter((term) => term.length > 1)
        }

        return input.filter((inputItem: FilterSearchInputItem) => {
            const normalizedInputStr = this.normalizeString(this.filterSearchInputItemToString(inputItem))
            return termsArray.some((term) => {
                const reg = new RegExp(term, 'i')
                return reg.test(normalizedInputStr)
            })
        })
    }

    public filterSearchInputItemToString(inputItem: FilterSearchInputItem): string {
        if (inputItem.constructor === String) {
            return inputItem as string
        }

        return inputItem.toString()
    }

    public normalizeString(input: string): string {
        return (input || '')
            .trim()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-zA-Z0-9]/g, '')
    }

}
